import React, { useState, useRef, useImperativeHandle, forwardRef } from "react"
import { Modal, Button, Form, Input, Col, Row, Tabs } from "antd"
import Printable from "../../pages/Loginv2/Calculators/Results/Printable/Printable"
import useGeneratePDF from "../../customHooks/useGeneratePDF"
import ChromeGIF from "../../assets/GIF/RTLSS_Chrome_Save.gif"
import EdgeGIF from "../../assets/GIF/RTLSS_Edge_Save.gif"
import FirefoxGIF from "../../assets/GIF/RTLSS_Firefox_Save.gif"


export const SaveAsPDFModal = forwardRef(({ result, units, data }, ref) => {
    const [open, setOpen] = useState(false)
    const [form] = Form.useForm()
    const [printData, setPrintData] = useState(null) // store all data for Printable

    const componentRefToPrint = useRef(null)
    const { reactToPrint } = useGeneratePDF(componentRefToPrint)
    const [activeKey, setActiveKey] = useState("chrome");
    // const { reactToPrint } = useGeneratePDF(componentRefToPrint, () => {
    //     Modal.confirm({
    //         title: "Did you save your PDF?",
    //         content: "If yes, we’ll close this window.",
    //         onOk: () => setOpen(false),
    //     })
    // })
    useImperativeHandle(ref, () => ({
        open: () => setOpen(true),
        close: () => setOpen(false),
    }))

    const handleSave = async () => {
        try {
            const values = await form.validateFields()

            setPrintData({
                result,
                units,
                data,
                laserName: values.laserName,
            })

            setTimeout(() => {
                reactToPrint()
            }, 0)

            setOpen(false)
            form.resetFields()
        } catch (err) {
            console.error("Validation failed:", err)
        }
    }
    const browserTabs = [
        { key: "chrome", label: "Google Chrome", src: ChromeGIF },
        { key: "edge", label: "Microsoft Edge", src: EdgeGIF },
        { key: "firefox", label: "Mozilla Firefox", src: FirefoxGIF },
        { key: "safari", label: "Safari", src: null },
    ];

    return (
        <>
            <Modal
                open={open}
                closable onCancel={() => setOpen(false)}
                footer={null}
                width= "70%"
                style={{ maxWidth: 850 }}>

                <Form form={form} layout="vertical">
                    <Form.Item
                        label="Enter Laser Name"
                        name="laserName"
                        rules={[{ required: true, message: "Please enter a laser name" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Tabs
                        defaultActiveKey="chrome"
                        centered
                        destroyInactiveTabPane
                        onChange={(key) => setActiveKey(key)}
                        items={browserTabs.map((item) => ({
                            key: item.key,
                            label: item.label,
                            disabled: !item.src,
                            children:
                                activeKey === item.key ? (
                                    <div style={{ textAlign: "center", padding: "16px" }}>
                                        <img
                                            src={item.src}
                                            alt={item.label}
                                            style={{ maxWidth: "65%", height: "auto", maxHeight: "40vh", borderRadius: "8px" }}
                                        />
                                    </div>
                                ) : null,
                        }))}
                    />

                    Save as PDF Instructions:
                    <ol>
                        <li>After you click Save, a print preview window will pop up.</li>

                        <li>In the Destination dropdown, select <b>Save as PDF</b>.</li>

                        <li>Click <b>Save</b>, then enter a file name when prompted.</li>
                        {/* <li>Under Pages, make sure it is set to <b>All</b>.</li> */}

                        {/* <li>For Pages per sheet, choose 1.</li> */}

                        {/* <li>Set Margins to Default.</li> */}

                        <li>Once everything is set, click Save to download your PDF.</li>

                    </ol>
                    <Button type="primary" onClick={handleSave} block>
                        Save
                    </Button>
                </Form>
            </Modal>

            {printData && (
                <Printable
                    ref={componentRefToPrint}
                    {...printData}
                />
            )}
        </>
    )
})
